import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

client.interceptors.request.use((config) => {
  const token = localStorage.getItem("mizizi_session");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default client;

export const getSession = () => localStorage.getItem("mizizi_session");
export const setSession = (t) => localStorage.setItem("mizizi_session", t);
export const clearSession = () => localStorage.removeItem("mizizi_session");
